import React, { Component } from 'react'
import { ThePermission } from 'src/containers/ThePermission';
import {
    CDataTable,
    CButton,
    CSelect,
    CLink,
    CPopover,
    CRow,
    CCol,
    CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { helps } from '../../_helpers';
import configs from 'src/appConfigs';
import Loading from 'src/containers/_loading';
import Select from 'react-select';
import DocView from './DocView';

class Docs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            modals: [],
        }

        this.pageChange = this.pageChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    componentDidMount() {
        const queryPage = this.props.location.search.match(/page=([0-9]+)/, '');
        const currentPage = Number(queryPage && queryPage[1] ? queryPage[1] : 1);
        this.setState({ currentPage: currentPage });
    }

    pageChange = (newPage) => {
        var currentPage = this.state.currentPage;
        currentPage !== newPage && this.props.history.push(`/users?page=${newPage}`)
    }

    handleChange(field, e) {
        var value = e.target.value;
        if (value === "true" || value == "false") {
            value = JSON.parse(value);
        }
        this.setState({
            [field]: value
        });
    }

    handleSelect(selectOPtions, field) {
        this.setState({
            [field]: selectOPtions,
        });
    }

    toggleModal = (item) => {
        let modals = this.state.modals;
        const position = modals.indexOf(item);
        let newItems = modals.slice();
        if (position !== -1) {
            newItems.splice(position, 1)
        } else {
            newItems = [...modals, item]
        }
        this.setState({ modals: newItems });
        console.log(item)
    }

    render() {
        const { docs, tags, users, categories, notes, employees, customers, housings, vendors, projects } = this.props;

        var _docs = !helps.isEmpty(docs) ? docs : [];
        if (!helps.isEmpty(this.state.category_id)) {
            _docs = _docs.filter(doc => doc.category_id === this.state.category_id)
        }

        let select_tags = this.state.select_tags;
        if (!helps.isEmpty(select_tags)) {
            _docs = _docs.filter((item) => {
                if (!helps.isEmpty(item.tags) && item.tags.length > 0) {
                    let found = helps.getItemFromArr(item.tags, select_tags['value'], 'value');
                    if (!helps.isEmpty(found)) return true;
                    else return false;
                } else {
                    return false;
                }
            });
        }

        var tag_options = [];
        if (!helps.isEmpty(tags)) {
            tags.forEach((tag) => {
                tag_options.push({
                    value: tag.id,
                    label: tag.name,
                });
            });
        }

        const fields = [
            { key: 'inc', label: '#', filter: false, _style: { width: '20px' } },
            { key: 'title', label: 'Tiêu đề', _classes: 'font-weight-bold', _style: { width: '20%' } },
            { key: 'number', label: 'Số', _classes: 'font-weight-bold', _style: { width: '10%' } },
            { key: 'category_id', label: 'Phân loại', _style: { width: '7%' } },
            { key: 'start_date', label: 'Từ ngày', filter: false },
            { key: 'tags', label: 'Nhãn', _style: { width: '10%', align: 'center' } },
            { key: 'attachment', label: 'Đính kèm', _style: { width: '15%' }, filter: false },
            { key: 'object_name', label: 'Áp dụng', filter: false },
            { key: 'object_id', label: 'Đối tượng', filter: false },
            { key: 'replace_for', label: 'Thay thế cho', filter: false },
            { key: 'create_by_alias', label: 'Tạo Bởi', _style: { align: 'center' }, filter: false },
            { key: 'actions', label: 'Thao Tác', _style: { width: '5%' }, filter: false, sorter: false },
        ]
        if (this.props.loading) {
            return (
                <Loading></Loading>
            );
        }
        return (
            <CRow>
                <CCol>
                    <CDataTable
                        key={'docs_' + _docs.length}
                        items={_docs}
                        fields={fields}
                        columnFilter
                        tableFilter={{ label: 'Tìm Kiếm: ', placeholder: '...', _classes: 'font-weight-bold' }}
                        itemsPerPageSelect={configs.itemsPerPageSelect}
                        itemsPerPage={configs.per_page}
                        hover
                        sorter
                        pagination
                        striped
                        columnFilterSlot={{
                            category_id: (
                                <>
                                    <CSelect
                                        name="category_id"
                                        id="input-category_id"
                                        className="form-control form-control-sm"
                                        value={this.state.category_id}
                                        onChange={(e) => { this.handleChange('category_id', e) }}
                                    >
                                        <option value="">-Tất cả-</option>
                                        {categories && categories.map((category) => {
                                            return (
                                                <option value={category.id} key={category.id}>{category.name} ({category.code})</option>
                                            )
                                        }
                                        )}
                                    </CSelect>
                                </>
                            ),
                            tags: (
                                <Select
                                    name="select-tag"
                                    placeholder="chọn Nhãn..."
                                    isClearable
                                    options={tag_options}
                                    defaultValue={this.state.select_tags}
                                    onChange={(selectOptions) => { this.handleSelect(selectOptions, 'select_tags') }}
                                >

                                </Select>
                            ),
                        }}
                        scopedSlots={{
                            'inc': (item, inc) => {
                                return (
                                    <td className="py-2">
                                        {inc + 1}
                                    </td>
                                )
                            },
                            'title': (item) => {
                                var _notes = [];
                                if (!helps.isEmpty(notes) && notes.length > 0) {
                                    _notes = notes.filter(note => note.object_id === item.id);
                                }
                                var note_content = '';
                                if (!helps.isEmpty(_notes) && _notes.length > 0) {
                                    note_content = _notes.map((note) => {
                                        return (
                                            <div className='border-bottom mb-2 pb-2'>
                                                {note.content} <small>_<i className='text-muted'>{helps.formatDateTime_from_Timestamp(note.note_time) + ' | ' + note.note_by_alias}</i></small>
                                            </div>
                                        );
                                    });
                                }
                                return (
                                    <td className="py-2" id={item.id}>
                                        {!helps.isEmpty(note_content) &&
                                            <CPopover
                                                header='Ghi chú:'
                                                content={note_content}
                                            >
                                                <CLink className="text-dark" onClick={() => { this.props.history.push(`/docs/view/${item.id}`) }}>
                                                    {item.active && <b>{item.title}</b>}{!item.active && <b><del>{item.title}</del></b>}
                                                </CLink>
                                            </CPopover>
                                        }
                                        {helps.isEmpty(note_content) &&
                                            <CLink className="text-dark" onClick={() => { this.toggleModal(item.id) }}>
                                                <b>{item.title}</b>
                                            </CLink>
                                        }
                                        <DocView {... this.props} toggleModal={this.toggleModal} item={item} modals={this.state.modals} />
                                    </td>
                                )
                            },
                            'number': (item) => {
                                return (
                                    <td className="py-2">
                                        <CLink className="text-dark" onClick={() => { this.toggleModal(item.id) }}>
                                            <b>{item.number}</b>
                                        </CLink>
                                    </td>
                                )
                            },
                            'category_id': (item) => {
                                let category = helps.getItemFromArr(categories, item.category_id);
                                return (
                                    <td className="py-2">
                                        <b>{category.code}</b>
                                    </td>
                                )
                            },
                            'start_date': (item) => {
                                return (
                                    <td className="py-2">
                                        <b>{helps.formatDate_from_Timestamp(item.start_date)}</b>
                                    </td>
                                )
                            },
                            'tags': (item) => {
                                return (
                                    <td className="py-2 text-center">
                                        {item.tags && item.tags.length > 0 && item.tags.map((tag) => {
                                            let _tag = helps.getItemFromArr(tags, tag.value);
                                            return (
                                                <CLink
                                                    key={item.id + '_' + _tag.id}
                                                    onClick={(e) => { e.preventDefault(); this.handleSelect({ value: _tag.id, label: _tag.name }, 'select_tags') }}
                                                    title={'Lọc theo Nhãn: ' + _tag.name}
                                                >
                                                    <CBadge key={_tag.id} color={_tag.color} className="p-1 m-1">
                                                        {_tag.name}
                                                    </CBadge>
                                                </CLink>
                                            )
                                        })}
                                    </td>
                                )
                            },
                            'attachment': (item) => {

                                return (
                                    <td className="py-2">
                                        {!helps.isEmpty(item.attachment) && item.attachment.length > 0 && item.attachment.map((_file) => {
                                            var _file_name = '';
                                            if (_file.name.length > 30) {
                                                _file_name = _file.name.substr(0, 30) + '...';
                                            } else {
                                                _file_name = _file.name;
                                            }
                                            return (
                                                <div key={item.id + '-' + _file.name} >
                                                    <CIcon name="cil-link" className="mfe-1 mt-0"></CIcon>
                                                    <CPopover
                                                        content={_file.name}
                                                    >
                                                        <CLink href={_file.url} target='_blank'> {_file_name}</CLink>
                                                    </CPopover>
                                                </div>
                                            )

                                        })}
                                    </td>
                                )
                            },
                            'object_name': (item) => {
                                return (
                                    <td className="py-2">
                                        {configs.docs_objects[[item.object_name]]}
                                    </td>
                                )
                            },
                            'object_id': (item) => {
                                let object_name = item.object_name;
                                let object_id_alias = '';
                                switch (object_name) {
                                    case 'general':
                                        object_id_alias = '';
                                        break;
                                    case 'branches':
                                        object_id_alias = configs.branches[[item.object_id]];
                                        break;
                                    case 'groups':
                                        object_id_alias = configs.groups[[item.object_id]];
                                        break;
                                    case 'departments':
                                        object_id_alias = configs.departments[[item.object_id]];
                                        break;
                                    case 'employees':
                                        let employee = helps.getItemFromArr(employees, item.object_id, 'employee_id');
                                        break;
                                    case 'customers':
                                        let customer = helps.getItemFromArr(customers, item.object_id);
                                        break;
                                    case 'projects':
                                        let project = helps.getItemFromArr(projects, item.object_id);
                                        break;
                                    case 'housings':
                                        let housing = helps.getItemFromArr(housings, item.object_id);
                                        break;
                                    case 'vendors':
                                        let vendor = helps.getItemFromArr(vendors, item.object_id);
                                        break;
                                    default:
                                        object_id_alias = '';
                                }
                                return (
                                    <td className="py-2">
                                        {!helps.isEmpty(item.object_id) && Array.isArray(item.object_id) && item.object_id.map(_item => {
                                            return (<div key={item.id + '-' + _item.value}>{_item.label}</div>)
                                        })}
                                        {!helps.isEmpty(item.object_id) && typeof item.object_id === 'string' && <div>{object_id_alias}</div>}
                                    </td>
                                )
                            },
                            'replace_for': (item) => {
                                let replace_for = helps.getItemFromArr(docs, item.replace_for);
                                return (
                                    <td className="py-2">
                                        <CLink className="text-dark" title={replace_for.title + '( ' + replace_for.number + ')'} onClick={() => { this.toggleModal(replace_for.id) }}>
                                            {!helps.isEmpty(replace_for) && <div>{replace_for.title} <i> ({replace_for.number})</i></div>}
                                        </CLink>
                                    </td>
                                )
                            },
                            'create_by_alias': (item) => {
                                let create_by_alias = helps.getUserAlias(users, item.create_by);
                                return (
                                    <td className="py-2">
                                        {create_by_alias}<br />
                                        <small className='text-muted font-italic'>{helps.formatDate_from_Timestamp(item.create_date)}</small>
                                    </td>
                                )
                            },
                            'actions':
                                (item) => {
                                    var _notes = [];
                                    if (!helps.isEmpty(notes) && notes.length > 0) {
                                        _notes = notes.filter(note => note.object_id === item.id);
                                    }
                                    var note_content = '';
                                    if (!helps.isEmpty(_notes) && _notes.length > 0) {
                                        note_content = _notes.map((note) => {
                                            return (
                                                <div className='border-bottom mb-2 pb-2'>
                                                    {note.content} <small>_<i className='text-muted'>{helps.formatDateTime_from_Timestamp(note.note_time) + ' | ' + note.note_by_alias}</i></small>
                                                </div>
                                            );
                                        });
                                    }
                                    return (
                                        <td className="py-2">
                                            <ThePermission {... this.props} component="docs" action="view">
                                                <CPopover
                                                    header="Ghi chú"
                                                    content={note_content}
                                                >
                                                    <CButton
                                                        color="info"
                                                        size="sm mr-1"
                                                    >
                                                        <CIcon name="cil-list"></CIcon>
                                                    </CButton>
                                                </CPopover>
                                            </ThePermission>
                                            <ThePermission {... this.props} component="docs" action="edit">
                                                <CButton
                                                    color="primary"
                                                    size="sm"
                                                    title="Cập nhật thông tin"
                                                    onClick={() => { this.props.history.push(`/docs/add_edit/${item.id}`) }}
                                                >
                                                    <CIcon name="cil-pen-nib"></CIcon>
                                                </CButton>
                                            </ThePermission>
                                        </td>
                                    )
                                },
                        }}
                    />
                </CCol>
            </CRow>
        )
    }
}


export default Docs;
